import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useParams, useHistory, useRouteMatch } from "react-router-dom"
import { Button, Form, Input, Row, Col, Switch, notification } from "antd"
import { LeftOutlined } from "@ant-design/icons"
import nodePath from "path"
import { requestNotification } from "../../../../lib/notifications"
import { isEmpty } from "lodash"

import { fetchCostParameter, selectCostParameter, setCostParameter, submitCostParameter } from "../costParametersSlice"

export default function CostParameterForm({ actionName }) {
    const { url } = useRouteMatch()
    const history = useHistory()
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const costParameter = useSelector(selectCostParameter)
    const { costParameterId } = useParams()

    useEffect(() => {
        if (costParameterId) {
            dispatch(fetchCostParameter(costParameterId))
        } else {
            dispatch(setCostParameter({}))
        }
    }, [dispatch, costParameterId])

    useEffect(() => {
        form.resetFields()
    }, [form, costParameter])

    const submit = async (values) => {
        const response = await dispatch(submitCostParameter(values, costParameterId))

        if (response.success) {
            actionName === "edit" ? history.push(`${nodePath.join(url, "../..")}`) : history.push(`${nodePath.join(url, "..")}`)
        }

        requestNotification(response)
    }

    // when setting the initial values, in order to set active to true by default, based on component lifecycle,
    // we need to check if we have a costParameter or not (new vs edit), and set it either to the object's value
    // or to true if we have no object... that is the only way i could really get it to work properly.
    return (
        <div id="user-form-container">
            <Link to={"/settings/cost_parameters"}>
                <LeftOutlined />
                Go Back
            </Link>
            <Form form={form} initialValues={{ ...costParameter, active: isEmpty(costParameter) ? true : costParameter.active }} onFinish={submit} layout="vertical">
                <div className="card">
                    <div className="card-body">
                        <div>
                            <Row gutter={24}>
                                <Col span={8}>
                                    <Form.Item label="Name" name="name" rules={[{ required: true }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>

                                <Col span={8}>
                                    <Form.Item label="Active" name="active" valuePropName="checked" rules={[{ required: true }]}>
                                        <Switch />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Form.Item>
                                <Button type="primary" htmlType="submit">
                                    Submit
                                </Button>
                            </Form.Item>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    )
}
